import { Component } from '@angular/core';
import {
  PanelContainerComponent,
  PanelHeaderComponent,
  PanelBodyComponent,
} from 'src/app/shared/content-panels';
import { TokenClaimsService } from 'src/app/shared/services';
import { EnergyCreditSupportComponent } from "../energy-credit-support/energy-credit-support.component";
import { QbuiltSupportComponent } from "../qbuilt-support/qbuilt-support.component";

@Component({
    selector: 'app-support-container',
    imports: [PanelContainerComponent, PanelHeaderComponent, PanelBodyComponent, EnergyCreditSupportComponent, QbuiltSupportComponent],
    templateUrl: './support-container.component.html',
    styleUrl: './support-container.component.scss'
})
export class SupportContainerComponent {
  isEcAdmin: boolean = false;
  isQBuiltAdmin: boolean = false;
  constructor(private claimsService: TokenClaimsService) {
    this.isEcAdmin = this.claimsService.isEnergyCreditAdmin;
    this.isQBuiltAdmin = this.claimsService.canAccessHomeOfficeAdmin;
  }
}
